import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ReactiveFormsModule, UntypedFormGroup} from '@angular/forms';
import {OpportunityStatuses} from '../../interfaces/opportunity-statuses.enum';
import {OpportunityStages} from '../../interfaces/opportunity-stages.enum';
import {Opportunity} from '../../interfaces/opportunity.interface';
import {OpportunityLossReasons} from '../../interfaces/opportunity-loss-reason.enum';
import {FollowUp} from '../../interfaces/follow-up.interface';
import {MatOption} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatError, MatFormField, MatInput, MatLabel} from '@angular/material/input';
import {MatSelect} from '@angular/material/select';
import {KeyValuePipe} from '@angular/common';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {MatIconModule} from "@angular/material/icon";


@Component({
    selector: 'app-follow-up-form',
    templateUrl: 'follow-up-form.component.html',
    imports: [
        MatOption,
        MatLabel,
        MatFormField,
        MatError,
        MatSelect,
        KeyValuePipe,
        ReactiveFormsModule,
        MatInput,
        CdkTextareaAutosize,
        MatDatepickerModule,
        MatIconModule
    ],
    styleUrls: [
        './follow-up-form.component.scss'
    ]
})
export class FollowUpFormComponent implements OnInit, OnDestroy {

    _opportunity: Opportunity;
    @Input() set opportunity(opp: Opportunity | null) {
        console.log('follow up form got Opportunity: ', opp);
        this._opportunity = opp;
    }

    @Input() followUp: FollowUp | null;

    @Input() mode: 'display' | 'create' | 'edit' = 'display';

    @Input() formGroup: UntypedFormGroup;

    readonly OpportunityStatuses = OpportunityStatuses;
    readonly OpportunityLossReasons = OpportunityLossReasons;
    readonly OpportunityStages = OpportunityStages;

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor() {
    }

    ngOnInit() {
        if (this.mode === 'create' || this.mode === 'edit') {
            this.formGroup.get('opportunityStage').valueChanges
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(value => {
                    switch (value) {
                        case OpportunityStages.LOST:
                        case OpportunityStages.RINUNCIATA_DA_EXTRAVEGA:
                        case OpportunityStages.SOSPESA_DAL_CLIENTE:
                            this.formGroup.get('status').setValue(OpportunityStatuses.LOST);
                            this.formGroup.get('lostBecause').enable();
                            break;
                        case OpportunityStages.WON:
                            this.formGroup.get('status').setValue(OpportunityStatuses.WON);
                            this.formGroup.get('lostBecause').disable();
                            break;
                        default:
                            this.formGroup.get('status').setValue(OpportunityStatuses.IN_PROGRESS);
                            this.formGroup.get('lostBecause').disable();
                            break;
                    }
                });
        }

        if (this.mode === 'create') {
            const today = new Date();
            const patchObj = {
                opportunityId: this._opportunity.id,
                latest: true,
                previous: this._opportunity.latestFollowUp,
                status: this._opportunity.status,
                opportunityStage: this._opportunity.opportunityStage,
                lostBecause: this._opportunity.lostBecause,
                revisionNumber: this._opportunity.revisionNumber,
                proposalSentOn: this._opportunity.proposalSentOn,
                proposalRequested: this._opportunity.proposalRequested,
                followUpDate: new Date(),
                nextFollowUpDate: new Date(today.setDate(today.getDate() + 14)),
                potentialClosureQuarter: this._opportunity.potentialClosureQuarter,
                potentialClosureYear: this._opportunity.potentialClosureYear,

                currency: this._opportunity.currency,
                exchangeRate: this._opportunity.exchangeRate,
                forecastAmountITA: this._opportunity.forecastAmountITA,
                forecastAmountUSA: this._opportunity.forecastAmountUSA
            };

            this.formGroup.patchValue(patchObj);
        } else if (this.mode === 'edit') {
            this.formGroup.patchValue(this.followUp);
        }
    }

    ngOnDestroy() {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }

    get isLost() {
        return [
            OpportunityStages.LOST,
            OpportunityStages.RINUNCIATA_DA_EXTRAVEGA,
            OpportunityStages.SOSPESA_DAL_CLIENTE
        ].includes(this.formGroup.get('opportunityStage').value);
    }
}
